import React, { useState, useEffect, useRef } from "react";
import "./sidebar.css";
import {MarkerFaction, MarkerTypes} from "../../../shared/data/marker-type.enum";

export default function Sidebar({
                                    onSelectMarker,
                                    selectedMarker,
                                    onRemoveSelectedMarker,
                                    onResetMarkers,
                                }) {
    const [isOpen, setIsOpen] = useState(false);
    // Detect mobile devices (for click instead of hover)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [markerFaction, setMarkerFaction] = useState(MarkerFaction.FRIENDLY);

    // Create a ref to reference the sidebar container.
    const sidebarRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Listen for clicks outside the sidebar to close it.
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isOpen && sidebarRef.current && !sidebarRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen]);

    // Toggle sidebar function
    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    function onClickButton() {
        if (!selectedMarker) {
            toggleSidebar();
        } else {
            onRemoveSelectedMarker();
        }
    }

    function handleMenuItemClick(markerType, markerFaction) {
        onSelectMarker(markerType, markerFaction); // Select the marker
        setIsOpen(false); // Close the sidebar
    }

    function handleResetClick() {
        onResetMarkers(markerFaction); // Reset markers
        setIsOpen(false); // Close the sidebar
    }

    return (
        <div
            id="sidebar-container"
            ref={sidebarRef}
            onMouseEnter={!isMobile ? () => setIsOpen(true) : undefined}
            onMouseLeave={!isMobile ? () => setIsOpen(false) : undefined}
        >
            {/* Sidebar */}
            {isOpen && (
                <div id={isOpen ? "sidebar-open" : "sidebar"}>
                    <h3 id="sidebar-title">Marker</h3>
                    <ul className={`menu ${markerFaction === MarkerFaction.FRIENDLY ? "friendly" : "enemy"}`}>
                        <li onClick={() => handleMenuItemClick(MarkerTypes.GARRISON, markerFaction)}>
                            Garrison
                        </li>
                        <li onClick={() => handleMenuItemClick(MarkerTypes.OUTPOST, markerFaction)}>
                            Outpost
                        </li>
                        <li onClick={() => handleMenuItemClick(MarkerTypes.SUPPLIES, markerFaction)}>
                            Supplies
                        </li>
                        <li onClick={() => handleMenuItemClick(MarkerTypes.SUPPLY_DROP, markerFaction)}>
                            Supply Drop
                        </li>
                        <li onClick={() => handleMenuItemClick(MarkerTypes.TANK_RECON, markerFaction)}>
                            Recon Tank
                        </li>
                        <li onClick={() => handleMenuItemClick(MarkerTypes.TANK_LIGHT, markerFaction)}>
                            Light Tank
                        </li>
                        <li onClick={() => handleMenuItemClick(MarkerTypes.TANK_MEDIUM, markerFaction)}>
                            Medium Tank
                        </li>
                        <li onClick={() => handleMenuItemClick(MarkerTypes.TANK_HEAVY, markerFaction)}>
                            Heavy Tank
                        </li>
                        <li id="reset-button" onClick={handleResetClick} style={{ color: "red" }}>
                            Reset
                        </li>
                    </ul>
                    <div id="faction-selector">
                        <a
                            id={markerFaction === MarkerFaction.ENEMY ? "faction-enemy-selected" : "faction-enemy"}
                            onMouseEnter={!isMobile ? () => setMarkerFaction(MarkerFaction.ENEMY) : null}
                            onClick={isMobile ? () => setMarkerFaction(MarkerFaction.ENEMY) : null}
                        />
                        <a
                            id={markerFaction === MarkerFaction.FRIENDLY ? "faction-friendly-selected" : "faction-friendly"}
                            onMouseEnter={!isMobile ? () => setMarkerFaction(MarkerFaction.FRIENDLY) : null}
                            onClick={isMobile ? () => setMarkerFaction(MarkerFaction.FRIENDLY) : null}
                        />
                    </div>
                </div>
            )}

            {/* Floating Toggle Button */}
            <div
                className={`floating-button ${selectedMarker ? "open" : ""}`}
                onClick={onClickButton}
            >
                {selectedMarker ? "x" : "+"}
            </div>
        </div>
    );
}
